var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.252 11.5C21.2554 12.8199 20.947 14.1219 20.352 15.3C19.6464 16.7118 18.5617 17.8992 17.2194 18.7293C15.8771 19.5594 14.3302 19.9994 12.752 20C11.4321 20.0035 10.1301 19.6951 8.95195 19.1L3.25195 21L5.15195 15.3C4.55688 14.1219 4.24851 12.8199 4.25195 11.5C4.25256 9.92179 4.69256 8.37488 5.52267 7.03258C6.35278 5.69028 7.54021 4.6056 8.95195 3.90003C10.1301 3.30496 11.4321 2.99659 12.752 3.00003H13.252C15.3363 3.11502 17.305 3.99479 18.7811 5.47089C20.2572 6.94699 21.137 8.91568 21.252 11V11.5Z",
    stroke: "var(--color-icon-new-conversation-stroke, #25282B)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.252 8V16",
    stroke: "var(--color-icon-new-conversation-stroke, #25282B)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25195 12H16.252",
    stroke: "var(--color-icon-new-conversation-stroke, #25282B)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.1a4e0b5f59cbc1a44c4f754177758cb5.svg";
export { ForwardRef as ReactComponent };